/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef } from 'react';

import { useParams, useHistory, Link } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Button, CardFooter,
  Nav, NavItem, NavLink, TabContent, TabPane, Badge, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';

import {
  Table, Tbody, Tr, Th, Td, Thead,
} from 'react-super-responsive-table';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import classnames from 'classnames';
import moment from 'moment';
import { Can } from '../../utilities/Can';
import {
  get, put, del, post,
} from '../../helpers/api_helper';
import TechOrderForm from '../../components/Fuse/TechOrderForm';

function FuseWorkorder(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const { id } = useParams();
  const [entity, setEntity] = useState(null);
  const [signal, setSignal] = useState(1);
  const [staticAvailability, setStaticAvailability] = useState(null);
  const [activeTab, setActiveTab] = useState('99');
  const [finishModal, setFinishModal] = useState(false);
  const [remoteData, setRemoteData] = React.useState(null);
  const [instructionSkuItem, setInstructionSkuItem] = useState(null);
  const [stockId, setStockId] = useState(null);

  const shelfLabelRef = useRef(null);
  const stockIdRef = useRef(null);
  const lotRef = useRef(null);
  const serialRef = useRef(null);

  const history = useHistory();

  const getStaticAvailability = async () => {
    try {
      const res = await get(`/api/fuse/workorder/static/${entity.listing.id}`);

      setStaticAvailability(res.static_qty);
    } catch (error) {
      toastr.error(error.message, t('Error'));
    }
  };

  const fetchRemoteDataByItemId = async (itemId) => {
    try {
      const response = await get(`/api/burnsville/inventoryByItemId/${itemId}`);
      setRemoteData(response);

      setStockId(response.stock_id);
    } catch (error) {
      toastr.error(props.t('Error fetching remote inventory data', error.message));
    }
  };

  const getEntity = async () => {
    try {
      const ent = await get(`/api/fuse/workorder/${id}`);

      setEntity(ent);

      await fetchRemoteDataByItemId(ent.listing.items[0].id);
    } catch (error) {
      toastr.error(error.message, t('Error'));
    }
  };

  useEffect(() => {
    getEntity();
  }, [id, signal]);

  useEffect(() => {
    if (entity !== null) {
      getStaticAvailability();

      if (entity.tech_orders.length > 0) {
        setActiveTab('0');
      }
    }
  }, [entity]);

  const print = async () => {
    try {
      await post(`/api/burnsville/printDZLabel/${stockId}`, {
        lot: lotRef.current.value,
        serial: serialRef.current.value,
        part_number: remoteData.part_number,
        qty: entity.qty,
      });

      lotRef.current.value = '';
      serialRef.current.value = '';
      shelfLabelRef.current.value = '';
    } catch (error) {
      toastr.error(props.t('Error printing label.'), error.message);
    }
  };

  const markComplete = async () => {
    try {
      await put(`/api/fuse/workorder/${id}/complete?item_id=${remoteData.sj_sku}`);

      toastr.success('Success!', 'Workorder marked as complete');
      setSignal(signal + 1);
      setFinishModal(false);
    } catch (error) {
      toastr.error(error.message, 'Error marking as complete');
    }
  };

  const assign = async () => {
    try {
      await put(`/api/fuse/workorder/${id}/assign`);

      toastr.success('Success!', 'Workorder assigned');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error assigning workorder');
    }
  };

  const detach = async (saleItemId) => {
    try {
      await del(`/api/fuse/workorder/${id}/detach/${saleItemId}`);

      toastr.success('Success!', 'Workorder assigned');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error assigning workorder');
    }
  };

  const closeWorkorder = async () => {
    try {
      if (confirm(t('Are you sure?'))) {
        await del(`/api/fuse/workorder/${entity.id}`);

        toastr.success('Success!', 'Workorder closed!');
        history.push('/fuse/workorders');
      }
    } catch (error) {
      toastr.error(error.message, 'Error closing workorder');
    }
  };

  const getInstructionSkuItem = async () => {
    const comps = entity?.family.components.filter((c) => c.indexed_items
      .find((x) => x.id === entity.listing.items[0].id) !== undefined && c.scope === 'instruction');

    let sku = null;
    let comp = null;

    for (
      let i = 0;
      i < comps.length;
      i += 1
    ) {
      const pns = comps[i].instructions.match(/sj-([^\s]+)/gi);
      if (pns !== null) {
        // Make the SKU just the last one in the match in case there are multiple
        [sku] = pns.slice(-1);
        comp = comps[i];

        break;
      }
    }

    if (sku !== null) {
      try {
        const listing = await get(`/api/listings/data/bySku/${sku}`);

        await fetchRemoteDataByItemId(listing.items[0].id);
        return { item: listing.items[0], component: comp };
      } catch (error) {
        toastr.error(error.message, 'Error getting instruction sku item');
        return null;
      }
    }

    return null;
  };

  const completeModal = async () => {
    setInstructionSkuItem(await getInstructionSkuItem());
    setFinishModal(!finishModal);

    setTimeout(() => {
      shelfLabelRef.current.focus();
    }, 400);
  };

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="page-content fuse-workorder-page">
      <div className="container-fluid">
        <Row>
          <Col xxl="5">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {entity && entity.name}
              </CardHeader>
              <CardBody>
                <Can i="see" this="Fuse">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped fuse-workorder-table">
                      <Tbody>
                        <Tr>
                          <Th>{t('ID')}</Th>
                          <Td>{entity ? entity.id : '--'}</Td>
                        </Tr>
                        <Tr>
                          <Th>{t('Family')}</Th>
                          <Td>
                            {entity && (
                              <a href={`/fuse/${entity.family.id}`}>
                                {entity.family.name}
                              </a>
                            )}
                          </Td>
                        </Tr>
                        <Tr>
                          <Th>{t('Listing')}</Th>
                          <Td>
                            {entity && entity.listing.title}
                          </Td>
                        </Tr>
                        <Tr>
                          <Th>{t('Sku')}</Th>
                          <Td>
                            {entity && (
                              <a href={`/listing/${entity.listing.id}`}>
                                {entity.listing.sku}
                              </a>
                            )}
                          </Td>
                        </Tr>
                        <Tr>
                          <Th>{t('Static / Subs')}</Th>
                          <Td>
                            {staticAvailability}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>

                  <div className="hstack gap-2">
                    {entity && entity.finished_at === null && (
                      <>
                        {entity && entity.assigned_at === null && (
                          <Button color="default" size="sm" className="border" onClick={assign}>
                            <span className="mdi mdi-refresh" />
                            {' '}
                            {t('Assign to Me')}
                          </Button>
                        )}
                        <Button color="success" size="sm" className="border btn-soft-success text-dark" onClick={completeModal}>
                          <span className="mdi mdi-check-bold" />
                          {' '}
                          {t('Mark Completed')}
                        </Button>
                        <Button color="danger" size="sm" className="border btn-soft-danger" onClick={closeWorkorder}>
                          <span className="mdi mdi-close-thick" />
                          {' '}
                          {t('Destroy Workorder')}
                        </Button>
                      </>
                    )}
                  </div>
                </Can>

                <Can not i="see" this="Fuse"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                {t('Considered Sales')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="Fuse">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped fuse-workorder-table">
                      <Thead>
                        <Tr>
                          <Th>{t('Sale Date')}</Th>
                          <Th>{t('Reference')}</Th>
                          <Th>{t('Purchased')}</Th>
                          <Th>{t('Action')}</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {entity && entity.sale_items.map((x) => (
                          <React.Fragment key={x.id}>
                            <Tr class={x.sale.distributions.length > 0 ? 'table-success' : ''}>
                              <Td className="align-middle">
                                <small>{moment(x.sale.created_at).format('ddd, M/D/YYYY h:mma')}</small>
                                <br />
                                <small>
                                  <strong>{moment(x.sale.created_at).fromNow()}</strong>
                                </small>
                              </Td>
                              <Td className="align-middle">
                                <a href={`/sales/${x.sale.id}`}>
                                  {x.sale.reference1}
                                </a>
                              </Td>
                              <Td className="align-middle" style={{ minWidth: '100px' }}>{x.qty}</Td>
                              <Td className="align-middle">
                                <Button color="soft-danger" size="sm" title={t('Detach sale from workorder')} onClick={() => { detach(x.id); }}>
                                  <span className="mdi mdi-close-thick" />
                                </Button>
                              </Td>
                            </Tr>
                          </React.Fragment>
                        ))}
                      </Tbody>
                    </Table>
                  </div>
                </Can>
              </CardBody>
            </Card>
          </Col>

          <Col xxl="7">
            <Row>
              {entity && entity.finished_at === null
                && (() => {
                  const listingItemIds = new Set(
                    entity.listing.items.map((z) => z.id),
                  );

                  return entity.family.components
                    .filter(
                      (x) => [
                        'any', 'component',
                      ].includes(x.scope) || (x.indexed_items
                        .some((y) => listingItemIds.has(y.id)) && x.scope === 'instruction'),
                    )
                    .map((x) => (
                      <Col xxl="6" key={x.id}>
                        <Card className={x.scope === 'instruction' ? 'border border-danger' : ''}>
                          <CardHeader
                            className={x.scope === 'instruction' ? 'bg-danger text-white' : ''}
                          >
                            {x.description}
                          </CardHeader>
                          <CardBody>
                            <p>{x.instructions}</p>
                          </CardBody>
                        </Card>
                      </Col>
                    ));
                })()}
            </Row>

            <Row>
              <Col xxl="12">
                <Nav tabs>
                  {entity && entity.tech_orders.map((x, i) => (
                    <NavItem>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: (activeTab === i.toString()),
                        })}
                        onClick={() => {
                          toggle(i.toString());
                        }}
                      >
                        {`Tech Order #${x.id.toString()}`}
                      </NavLink>
                    </NavItem>
                  ))}
                  {entity && entity.finished_at === null && (
                    <NavItem>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: (activeTab === '99'),
                        })}
                        onClick={() => {
                          toggle('99');
                        }}
                      >
                        {t('Place Order')}
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>

                <TabContent activeTab={activeTab}>
                  {entity && entity.finished_at === null && (
                    <TabPane key="chn_tab_99" tabId="99">
                      <Card>
                        <CardBody>
                          {entity && (
                            <TechOrderForm
                              workorder={entity}
                              onSuccess={(to) => { setSignal(signal + 1); toastr.success('Tech order sent to remote!', `#${to.id} created`); }}
                              initialValues={{ reference: `Fuse workorder #${entity?.id}`, instructions: 'Deliver to my desk', items: [] }}
                            />
                          )}
                        </CardBody>
                        <CardFooter>
                          <Button color="soft-primary" form="TechOrderExportForm">{t('Submit Tech Order')}</Button>
                        </CardFooter>
                      </Card>
                    </TabPane>
                  )}
                  {entity && entity.tech_orders.map((x, i) => (
                    <TabPane key={`order_${x.id}`} tabId={i.toString()}>
                      <Card>
                        <CardBody>
                          <Table className="table table-bordered table-striped fuse-workorder-table">
                            <Thead>
                              <Tr>
                                <Td class="align-middle">
                                  {t('Img')}
                                </Td>
                                <Td class="align-middle">
                                  {t('ID')}
                                </Td>
                                <Td class="align-middle">
                                  {t('Part Number')}
                                </Td>
                                <Td class="align-middle">
                                  {t('Qty')}
                                </Td>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {x.items.map((xi) => (
                                <Tr>
                                  <td className="align-middle">
                                    <img className="rounded" style={{ maxWidth: '3rem', maxHeight: '3rem' }} src={`/api/items/thumbnail/${xi.id}`} alt={xi.part_number} />
                                  </td>
                                  <td className="align-middle">
                                    <a href={`/item/${xi.id}`}>
                                      {xi.id}
                                    </a>
                                  </td>
                                  <td className="align-middle">
                                    {xi.part_number}
                                    <div className="hstack gap-1 mt-1">
                                      {entity.family.components
                                        .filter((r) => r.indexed_items
                                          .find((w) => w.id === xi.id) && ['any', 'component'].includes(r.scope))
                                        .map((xx) => xx.description).map((xx) => (
                                          <Badge color="danger" className="btn-soft">
                                            <span className="mdi mdi-check-bold" />
                                            {' '}
                                            {xx}
                                          </Badge>
                                        ))}

                                      {xi.exact === 1 && (
                                        <Badge color="soft-success">
                                          <span className="mdi mdi-check-bold" />
                                          {' '}
                                          {t('Exact Match')}
                                        </Badge>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    {xi.item_qty}
                                  </td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </CardBody>
                      </Card>
                    </TabPane>
                  ))}
                </TabContent>
              </Col>
            </Row>
          </Col>
        </Row>

        <Modal size="md" isOpen={finishModal} toggle={() => setFinishModal(!finishModal)}>
          <ModalHeader toggle={() => setFinishModal(!finishModal)}>{t('Complete Workorder')}</ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="shelfLabel" className="form-label">{props.t('Shelf Label')}</label>
              <input
                type="text"
                ref={shelfLabelRef}
                className="form-control"
                id="shelfLabel"
                placeholder={props.t('Scan original shelf label into here...')}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter') {
                    const value = e.target.value.trim();
                    if (value) {
                      const serial = value.substring(15, 75).trim();
                      const lot = value.substring(75).trim();

                      lotRef.current.value = lot;
                      serialRef.current.value = serial;

                      await print();

                      shelfLabelRef.current.value = '';
                    } else {
                      toastr.error(props.t('Shelf label not recognized.'));
                    }
                  }
                }}
              />
              <div className="text-muted mt-1">
                {props.t('Populates the fields below by extracting lot and serial.')}
              </div>
            </div>
            <Row>
              <Col xs={6}>
                <div className="mb-3">
                  <label htmlFor="stockId" className="form-label">{props.t('Item')}</label>
                  <input type="hidden" ref={stockIdRef} name="stockId" value={stockId} />
                  <select
                    className="form-control"
                    id="stockId"
                    onChange={(e) => fetchRemoteDataByItemId(e.target.value)}
                  >
                    <option value={entity?.listing.items[0].id}>
                      {`${entity?.listing.items[0].part_number} - ${t('Original')}`}
                    </option>
                    {instructionSkuItem && (
                      <option
                        selected
                        key={instructionSkuItem.item.id}
                        value={instructionSkuItem.item.id}
                      >
                        {`${instructionSkuItem.item.part_number} - ${instructionSkuItem.component.description}`}
                      </option>
                    )}
                  </select>
                </div>
              </Col>
              <Col xs="6">
                {remoteData && (
                  <div className="hstack gap-2 mt-2">
                    <img src={`/api/items/thumbnail/${remoteData.sj_sku}`} alt={remoteData.part_number} className="img-thumbnail" style={{ width: '50px', height: '50px' }} />
                    <Link to={`/item/${remoteData.sj_sku}`}>{props.t(`${remoteData.part_number}`)}</Link>
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <div className="mb-3">
                  <label htmlFor="lot" className="form-label">{props.t('Lot')}</label>
                  <input type="text" ref={lotRef} className="form-control" id="lot" placeholder={props.t('Lot number')} />
                </div>
              </Col>
              <Col xs="6">
                <div className="mb-3">
                  <label htmlFor="serial" className="form-label">{props.t('Serial')}</label>
                  <input type="text" ref={serialRef} className="form-control" id="serial" placeholder={props.t('Serial')} />
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setFinishModal(!finishModal)}>{t('Cancel')}</Button>
            <Button color="primary" onClick={markComplete}>{props.t('Complete')}</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

FuseWorkorder.defaultProps = {
  t: (x) => (x),
};

FuseWorkorder.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(FuseWorkorder));
